import React from "react"
import Link from "gatsby-link"
import cx from "classnames"

import { Detail, Image } from "../../elements"
import { formatdate } from "../../../helpers"
import { GraphCms_Article } from "../../../../graphql-types"

type Props = {
  className?: string
  article: GraphCms_Article
}

function ArticleCard({ article, className }: Props) {
  let createdAt = formatdate(new Date(article.createdAt))

  return (
    <Link
      to={article.page?.url!.pathname ?? "/"}
      className={cx("block", className)}
    >
      <div className="flex mb-2 sm:mb-0">
        <div className="w-32 xs:w-40 md:w-56 mr-4 overflow-hidden rounded z-10">
          <Image
            className="block"
            gatsbyImageData={
              article.page!.image?.localFile?.childImageSharp?.gatsbyImageData
            }
            alt={article.title}
            zoom
          />
        </div>

        <div className="flex-1">
          <div className="flex justify-between mb-2">
            <Detail className="text-xs text-gray-dark">{createdAt}</Detail>
          </div>

          <Detail className="text-base font-bold mb-3">{article.title}</Detail>

          <Detail className="text-sm text-gray-dark hidden sm:block leading-6">
            {article.excerpt}
          </Detail>
        </div>
      </div>

      <Detail className="text-base text-gray-dark sm:hidden">
        {article.excerpt}
      </Detail>
    </Link>
  )
}

export default ArticleCard
